import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

import { ActiveErrorsStore, DiagStackOtxStore } from '@store';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-show-live-vdd',
  templateUrl: './show-live-vdd.component.html',
  styleUrls: ['./show-live-vdd.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowLiveVddComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public diagStackOtxStore: DiagStackOtxStore,
    public activeErrorsStore: ActiveErrorsStore
  ) {}

  ngOnInit(): void {
    this.activeErrorsStore.selectedActiveError$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => {
        this.diagStackOtxStore.getAvailableOtxSequencesAttempt();
      });
  }

  retryVddRead(): void {
    this.diagStackOtxStore.triggerOtxVddsReadAgain();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
